import * as React from 'react';
import { BaseSvg, SVGIconProps } from './BaseSvg';

export const TrashIcon: React.FC<SVGIconProps> = ({ size = 24, color = 'currentColor', ...props }) => (
  <BaseSvg width={size} height={size} viewBox="0 0 24 24" {...props}>
    <path
      d="M7.625 20C7.14375 20 6.73192 19.8261 6.3895 19.4782C6.0465 19.1298 5.875 18.7111 5.875 18.2222V6.66667H5V4.88889H9.375V4H14.625V4.88889H19V6.66667H18.125V18.2222C18.125 18.7111 17.9538 19.1298 17.6114 19.4782C17.2684 19.8261 16.8562 20 16.375 20H7.625ZM16.375 6.66667H7.625V18.2222H16.375V6.66667ZM9.375 16.4444H11.125V8.44444H9.375V16.4444ZM12.875 16.4444H14.625V8.44444H12.875V16.4444Z"
      fill={color}
    />
  </BaseSvg>
);
